import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgxResponsiveTableComponent } from './ngx-responsive-table.component';
import { NgxResponsiveTableDirective } from './ngx-responsive-table.directive';
import { NgxResponsiveTableService } from './ngx-responsive-table.service';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import { CommonModule } from '@angular/common';
import { TableControlPanelComponent } from './components/table-control-panel/table-control-panel.component';
import { DensityControlsComponent } from './components/density-controls/density-controls.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        NgxResponsiveTableComponent,
        NgxResponsiveTableDirective,
        ToggleSwitchComponent,
        TableControlPanelComponent,
        DensityControlsComponent,
    ],
    providers: [
        NgxResponsiveTableService,
    ],
    exports: [
        NgxResponsiveTableComponent,
        NgxResponsiveTableDirective,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NgxResponsiveTableModule {
}
